<template>
  <drop-down ref="dropDown" drop-down-class="table-filter-list" :hide-on-click="false">
    <div class="table-filter-list-item">
      <el-checkbox-group :value="filterRes" @input="$emit('filterChange', arguments[0])">
        <el-checkbox
          v-for="label in filterList"
          :label="label"
          :key="label"
        ></el-checkbox>
      </el-checkbox-group>
    </div>
  </drop-down>
</template>

<script>
  import DropDown from '../../../others/drop-down/drop-down'
  import { getFilterResHistory } from '../utils'

  export default {
    name: 'TableCloumnFilter',
    props: {
      filterList: Array,
      filterRes: Array
    },
    methods: {
      show (position) {
        const {
          dropDown
        } = this.$refs

        dropDown.show({
          top: position.top + 12,
          left: position.left
        })

        this.$nextTick(() => {
          dropDown.show({
            top: position.top + 12,
            left: position.left - dropDown.$el.offsetWidth
          })
        })
      },
      hide () {
        this.$refs.dropDown.hide()
      }
    },
    components: {
      DropDown
    }
  }
</script>